import SkillsChartCommunication from '~/pages/communication/skillsChart/libs/components/SkillsChartCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const SkillsChartCommunicationPage = (props: TPageProps) => (
  <SkillsChartCommunication {...props} />
)

export default SkillsChartCommunicationPage
